export function getDistanceMiles(lat1, lon1, lat2, lon2) {
  const R = 3959;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export const GRADE_RANK = { "A+": 0, "A": 1, "A-": 2, "B+": 3, "B": 4, "Pending Review": 9 };

export function sortByGradeAndRating(a, b) {
  return (GRADE_RANK[a.healthGrade] ?? 9) - (GRADE_RANK[b.healthGrade] ?? 9) || (b.googleRating || 0) - (a.googleRating || 0);
}

function longitudePadding(latitude, miles) {
  const cosine = Math.max(0.2, Math.cos(latitude * Math.PI / 180));
  return miles / (69 * cosine);
}

export function boundsAroundPoint([latitude, longitude], radiusMiles) {
  const latitudePadding = radiusMiles / 69;
  const lngPadding = longitudePadding(latitude, radiusMiles);
  return {
    north: Math.min(90, latitude + latitudePadding),
    south: Math.max(-90, latitude - latitudePadding),
    east: Math.min(180, longitude + lngPadding),
    west: Math.max(-180, longitude - lngPadding),
  };
}

export function boundsAroundPoints(points, paddingMiles) {
  if (!points.length) return null;
  const latitudes = points.map(([latitude]) => latitude);
  const longitudes = points.map(([, longitude]) => longitude);
  const middleLatitude = (Math.min(...latitudes) + Math.max(...latitudes)) / 2;
  const latitudePadding = paddingMiles / 69;
  const lngPadding = longitudePadding(middleLatitude, paddingMiles);
  return {
    north: Math.min(90, Math.max(...latitudes) + latitudePadding),
    south: Math.max(-90, Math.min(...latitudes) - latitudePadding),
    east: Math.min(180, Math.max(...longitudes) + lngPadding),
    west: Math.max(-180, Math.min(...longitudes) - lngPadding),
  };
}
